<template>
  <section
    v-if="carouselReviews.length > 0"
    class="home-reviews blue-grey lighten-5 pt-8 pt-sm-16 pb-sm-8"
  >
    <div class="section-header mb-10 mb-md-16">
      <h2 class="section-title text-center mb-2">
        {{ $t("what_our_guests_are_saying") }}
      </h2>
      <div class="section-accent mx-auto mb-4"></div>
    </div>
    <v-container>
      <site-carousel :items="carouselReviews" />
    </v-container>
  </section>
</template>

<script>
import { HOME_REVIEWS_TITLE } from "@/consts/CMS";
import { mapState, mapActions } from "vuex";
import SiteCarousel from "@/components/common/carousel/site-carousel.vue";
import moment from "moment";
import { cloudinaryDelivery } from "@/utils/cloudinary-delivery";

export default {
  name: "home-reviews",
  components: { SiteCarousel },
  data: () => ({
    HOME_REVIEWS_TITLE,
    slide: 0,
  }),
  props: ["listingReviews"],
  computed: {
    ...mapState({
      reviews: (state) => state.reviewsModule.items,
      carouselReviews() {
        return (this.listingReviews || this.reviews).map((r) => ({
          rating: +(r.normilized_scrore_overall / 2).toFixed(),
          body: r.public,
          name: r.source,
          date: moment(r.created_at).format("MMM D, YYYY"),
          image: cloudinaryDelivery(r.listing.picture)?.replace(
            "h_200",
            "h_500"
          ),
        }));
      },
    }),
  },
  methods: {
    ...mapActions("reviewsModule", ["getReviews"]),
  },
  mounted() {
    if (!this.listingReviews) {
      this.getReviews();
    }
  },
};
</script>

<style scoped>
.section-header {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.section-title {
  font-family: "Fraunces", serif;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}
.section-accent {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%);
  border-radius: 2px;
}
</style>
